export default __webpack_public_path__ + "static/media/icon-01.ca9c9877.svg";